import { render, staticRenderFns } from "./PaginationContainer.vue?vue&type=template&id=517caf1e&"
import script from "./PaginationContainer.vue?vue&type=script&lang=js&"
export * from "./PaginationContainer.vue?vue&type=script&lang=js&"
import style0 from "./PaginationContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports